import API from "./api";

export const issueInventory = async (issueData) => {
    try {
        const response = await API.post("/issue", issueData);
        return response.data;
    } catch (error) {
        console.error("Error issuing inventory:", error);
        throw error;
    }
};

export const getInventoryIssueLogs = async () => {
    try {
        const response = await API.get("/issue/logs");
        return response.data;
    } catch (error) {
        console.error("Error fetching inventory issue logs:", error);
        throw error;
    }
};